import { toMixedSchedule } from './to-mixed-schedule';
import { Injectable } from '@angular/core';
import {
  FrequencyType,
  Schedule,
  ScheduleModalFacade,
  MixedSchedule,
  RawSchedule,
} from '@mode/shared/schedules/contract';

@Injectable()
export class ScheduleModalFacadeService extends ScheduleModalFacade {
  public activeSchedule: MixedSchedule = {} as unknown as MixedSchedule;
  public frequencyType: FrequencyType = 'daily';
  public hasUpdate = false;
  public schedules: MixedSchedule[] = [];

  public setFrequencyType(newFrequency: FrequencyType) {
    this.frequencyType = newFrequency;
  }

  public loadRawSchedules(rawSchedules: RawSchedule[]) {
    this.schedules = rawSchedules.map((x) => toMixedSchedule(x));
  }

  public setActiveSchedule(rawSchedule: RawSchedule) {
    this.hasUpdate = false;
    this.activeSchedule = toMixedSchedule(rawSchedule);

    this.updateCron(this.activeSchedule['isWeekday'], rawSchedule, rawSchedule['cron'].freq);

    const originalSchedule = this.activeSchedule.cleanSchedule;
    const reset = () => {
      this.activeSchedule['cleanSchedule'] = { ...originalSchedule };
    };

    this.resetSchedule = reset;
  }

  public onScheduleNameChange(name: string) {
    this.activeSchedule.name = name;
    this.hasUpdate = true;
  }

  public onFrequencyChange({ rawSchedule, newFrequency }: { rawSchedule: RawSchedule; newFrequency: FrequencyType }) {
    const isWeekday = newFrequency === 'weekday';

    this.updateCron(isWeekday, rawSchedule, newFrequency);

    this.setFrequencyType(newFrequency);

    this.checkForMinuteReset(newFrequency);

    this.activeSchedule.cleanSchedule = { ...this.activeSchedule.cleanSchedule, frequency: newFrequency } as Schedule;
    this.activeSchedule['isWeekday'] = isWeekday;

    this.hasUpdate = true;
  }

  public startTimeChanged(minute: number): void {
    this.activeSchedule.cleanSchedule = { ...this.activeSchedule.cleanSchedule, minute };
    this.hasUpdate = true;
  }

  public scheduleChanged(rawSchedule: RawSchedule): void {
    this.activeSchedule = toMixedSchedule(rawSchedule);
    this.hasUpdate = true;
  }

  public setSlackChannel(channel: any) {
    this.activeSchedule['slackChannel'] = channel.name ? { type: 'public', ...channel } : null;
    this.hasUpdate = true;
  }

  public backClicked() {
    this.resetSchedule();
  }

  private checkForMinuteReset(frequency: FrequencyType) {
    const shouldResetMinute =
      (frequency === 'every_15_minutes' && this.activeSchedule.cleanSchedule.minute > 15) ||
      (frequency === 'every_30_minutes' && this.activeSchedule.cleanSchedule.minute > 30);

    if (shouldResetMinute) {
      this.activeSchedule.cleanSchedule = { ...this.activeSchedule.cleanSchedule, minute: 0 };
    }
  }

  private resetSchedule = () => {};

  private updateCron(isWeekday: boolean, rawSchedule: RawSchedule, newFrequency: FrequencyType) {
    if (isWeekday) {
      rawSchedule['cron'].freq = 'weekly';
      rawSchedule['cron'].day_of_week = '1,2,3,4,5';
      rawSchedule['cron'].day_of_month = 1;
    } else {
      rawSchedule['cron'].freq = newFrequency;
      rawSchedule['cron'].day_of_week =
        rawSchedule['cron'].day_of_week === '1,2,3,4,5' ? 1 : rawSchedule['cron'].day_of_week;
    }
  }
}
